<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :modal="false"
      :visible="visible"
      width="1100px"
      :title="$t('SystemMaintenance.NumberOfClickUsers')"
      :close-on-click-modal="false"
      :show-close="true"
      @close="cancel"
    >

      <el-form :inline="true" label-width="60px" label-position="left" style="margin-top: 4px;">
        <div class="app-main-inner-row" style="padding: 0; margin-left: 10px;justify-content: flex-start;">
          <el-form-item :label="$t('SystemMaintenance.BelongingSystem')" class="el-form-item">
            <el-select v-model="filterJson.systemSource" disabled>
              <el-option
                v-for="item in systemSourceList"
                :key="item.code"
                :label="item.chineseName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.BelongToCompany')" class="el-form-item">
            <cargo-advance-select
              :select-type="selectTypeNames.TENANT"
              :cache="false"
              filterable
              :custom-label="(item)=>`[${item.id}]${item.name}`"
              callback-method-type="obj"
              :default-value="String(filterJson.tenantId)||''"
              @parentCallBack="changeTenant"
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.UserType')" class="el-form-item">
            <el-select v-model="filterJson.userType" clearable>
              <el-option
                v-for="item in userTypeList"
                :key="item.code"
                :label="item.chineseName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.Username')" class="el-form-item">
            <el-input
              v-model="filterJson.userName"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="toQuery()">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
          </el-form-item>
        </div>
        <div class="app-main-inner-row" style="padding: 0; margin-left: 10px;justify-content: flex-start;" />
        <div />
      </el-form>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="onReady"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          :page-count="filter.pageCount"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { getLoading } from '@/utils/utilBaseElement'
import { queryClickUserListFunc } from '@/api/sysManage/advertisingConfig'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'

export default {
  name: 'ClickUserWindow',
  components: { CargoAdvanceSelect, searchItem },
  props: {
    visible: { type: Boolean, required: true },
    params: { type: Object, required: true }
  },
  data() {
    return {
      loading: false,
      selectTypeNames: TYPE_NAMES,
      systemSourceList: SystemConstants.AD_SYSTEM_LIST,
      userTypeList: SystemConstants.WT_USER_TYPE_LIST,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      },
      columnDefs: [
        { headerName: this.$t('SystemMaintenance.Username'), field: 'clickUser', width: 150,
          valueFormatter: (params) => {
            if (params.value === this.$t('SystemMaintenance.PlatformCustomerService')) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.userId), 'chineseName')
            } else {
              return params.value
            }
          }
        },
        { headerName: this.$t('SystemMaintenance.BelongToCompany'), field: 'tenantName', width: 150 },
        { headerName: this.$t('SystemMaintenance.BelongingSystem'), field: 'systemSource', width: 120,
          valueFormatter: (params) => {
            const c = CommonState.getStateByCode(SystemConstants.AD_SYSTEM_LIST, params.value)
            if (c) {
              return c.chineseName
            }
            return ''
          }
        },
        { headerName: this.$t('SystemMaintenance.UserType'), field: 'userType', width: 120,
          valueFormatter: (params) => {
            const c = CommonState.getStateByCode(SystemConstants.WT_USER_TYPE_LIST, params.value)
            if (c) {
              return c.chineseName
            }
            return ''
          }
        },
        { headerName: this.$t('SystemMaintenance.ClickTime'), field: 'lastClickDate', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SystemMaintenance.BrowsingTime'), field: 'lastViewDate', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      isAdvancedQuery: true,
      filterJson: {
        userName: '',
        systemSource: '',
        tenantId: 0,
        userType: '',
        page: 1,
        branchId: 0, // 分公司ID
        conditions: [] // 查询条件
      },
      selectedData: null,
      filter: {
        total: 0,
        pageNum: 1,
        pageCount: 0,
        pageSize: 100
      },
      gridApi: null
    }
  },
  computed: {

  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.toQuery()
      }
    }
  },
  async beforeMount() {

  },
  mounted() {
  },
  methods: {
    onReady(params) {
      this.gridApi = params.api
    },
    // 分页查询
    toQuery() {
      this.filterJson.advertisingTitle = this.params.advertisingTitle
      this.filterJson.advertisingSpaceTitle = this.params.advertisingSpaceTitle
      this.filterJson.page = this.params.page
      this.filterJson.module = this.params.module
      this.filterJson.systemSource = this.params.systemSource
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      queryClickUserListFunc(this.filterJson).then(res => this.handleQueryData(res)).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.filter.pageCount = res.data.pages
      this.selectedData = null
      this.gridApi.clearFocusedCell()
      this.loading.close()
    },
    changeTenant(p) {
      this.filterJson.tenantId = p.value
    },
    cancel() {
      this.rowData = []
      this.selectedData = null
      this.$emit('cancelVisible')
    }
  }
}
</script>
<style scoped>
ul li {
  list-style: none;
  font-size: 13px;
  color: #909399;
}

.spacing {
  padding-top: 20px;
}
</style>

